module.exports = {
	"title": "Confirmation Page",
	"privacyPolicy": "Privacy Policy",
	"term": "Terms of Service",
	"phoneNumberText": "Please enter the phone number without the country code you used for the reservation.",
	"phoneNumber": "Phone Number",
	"phoneNumberError": "The phone number that you entered is incorrect, or the confirmation period has expired.",
	"phoneNumberEnabledButton": "Confirm the reservation",
	"phoneNumberDisabledButton": "Enter your phone number",
	"reservationCanceled": "This reservation is cancelled.",
	"reservationCancel": "This reservation was cancelled.",
	"course": "Course menu",
	"address": "Address",
	"phone": "Contact",
	"contents": "Reservation Details",
	"date": "Date & Time",
	"seats": "Party size",
	"adults": "Adults",
	"children": "Children",
	"request": "Special request",
	"reservationNumber": "Confirmation Number",
	"noText": "For changes and cancellations, please contact us directly via telephone. Please do so at least one day prior the date of your reservation.",
	"cancelButton": "Cancel Reservation",
	"people": "people",
	"confirm": "Cancel your reservation?",
	"start": "start",
	"deposit": "Deposit",
	"table_category": "Seat Type",
	"private": "Private Room",
	"counter": "Bar Seat",
	"table": "Table Seat",
	"none": "No preference",
	"yes": "Yes",
	"no": "No",
	"doCancel": "Are you sure you wish to cancel your reservation?"
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/en.json
// module id = 168
// module chunks = 0